import request from '@/utils/request'

let originEnv = ''
if (location.origin.indexOf('.qa') > -1 || location.origin.indexOf('10.') > -1) {
  originEnv = '.qa'
} else if (location.origin.indexOf('.t') > -1) {
  originEnv = '.t'
}

const base = `https://cvg${originEnv}.17usoft.com/backendActivity/`


export const tianyanCode = 'app.propublic.h5'

//获取任务状态
export const getTaskStatus = (data) => {
  return request({
    url: `${base}task/getladderTask`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    data
  })
}

//开启任务
export const openTask = (data) => {
  return request({
    url: `${base}task/opentask`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    data
  })
}

//领取权益
export const receiveRight = (data) => {
  return request({
    url: `${base}task/receiveright`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    data
  })
}


//权益查询
export const getRightInfo = (data) => {
  return request({
    url: `${base}right/queryright`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    data
  })
}